import { createContext } from 'preact';
import { useContext, useReducer } from 'preact/hooks';
import initialState from './initialState';
import { getCompaniesDispatcher } from './actionDispatchers';
import reducer from './reducer';

export const AutoCompleteContext = createContext();

const AutoCompleteProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const actions = {
    getCompanies: getCompaniesDispatcher(dispatch),
  };

  return (
    <AutoCompleteContext.Provider value={[state, actions]}>
      {children}
    </AutoCompleteContext.Provider>
  );
};

export function useAutoCompleteState() {
  return useContext(AutoCompleteContext);
}

export default AutoCompleteProvider;



// WEBPACK FOOTER //
// ./AutoComplete/context/index.js